import { Command } from 'pos/common';
import * as SalesStore from '../SalesStore';
import { Res, Permission } from 'core/api';
import { Result, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		printLastTicketGift: () => Promise<Result>
	}
}

Command.register('printLastTicketGift', Preconditions.ensure(Permission.Ticket_PrintGift), async (): Promise<Result> => {

	if (!SessionProvider.getCurrent().AllowPrintTicketGift) {
		await Message.show(Res.Msg.MSG_TPV_IS_NOT_ALLOWED_TO_PRINT_TICKET_GIFT());
		return Result.error();
	}

	const lastClosedInvoice = SalesStore.getLastClosedInvoice();
	if (!lastClosedInvoice) {
		await Message.show(Res.Msg.MSG_THERE_ARE_NOT_INVOICES_SINCE_DAY_WAS_OPENED());
		return Result.error();
	}

	await SalesStore.printInvoiceGift(lastClosedInvoice.invoiceId);
	return Result.ok();
});